import { render, staticRenderFns } from "./CampusRenewal.vue?vue&type=template&id=0ff4da92"
import script from "./CampusRenewal.vue?vue&type=script&lang=js"
export * from "./CampusRenewal.vue?vue&type=script&lang=js"
import style0 from "./CampusRenewal.vue?vue&type=style&index=0&id=0ff4da92&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports